export class LookupConstants {
// LookUp
  public static SHAPE_OVAL: string = 'OVAL';
  public static SHAPE_SQUARE: string = 'SQUARE';
  public static SERIAL: string = 'serial';
  public static STYLE: string = 'Style';
  public static STORE_ID: string = 'StoreId';
  public static UPC: string = 'UPC';
  public static QTY: string = 'QTY';
}



// WEBPACK FOOTER //
// ./src/pages/look-up/lookup.constants.ts